import { normalizeLocale, localized, type SupportedLocale } from '../../lib/i18n'
import type { AdminServiceTypeSummary, AdminUserSummary } from '../../graphql/admin'

function localeTag(locale: SupportedLocale) {
  return normalizeLocale(locale) === 'el' ? 'el-GR' : 'en-GB'
}

export function formatAdminCurrency(cents: number, locale: SupportedLocale) {
  return new Intl.NumberFormat(localeTag(locale), {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(cents / 100)
}

export function formatAdminDate(dateValue: string, locale: SupportedLocale) {
  return new Intl.DateTimeFormat(localeTag(locale), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(dateValue))
}

export function formatAdminDateTime(dateValue: string, locale: SupportedLocale) {
  return new Intl.DateTimeFormat(localeTag(locale), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(dateValue))
}

export function formatAdminTimeRange(startTime: string, endTime: string) {
  return `${startTime.slice(0, 5)} - ${endTime.slice(0, 5)}`
}

export function formatAdminUserName(user: Pick<AdminUserSummary, 'firstName' | 'lastName'>) {
  return `${user.firstName} ${user.lastName}`.trim()
}

export function formatAdminServiceType(serviceType: AdminServiceTypeSummary, locale: SupportedLocale) {
  return localized(serviceType, locale)
}
